import { useTranslations } from '~i18n/hooks';
import { ParticlesPlaceholder } from '~shared/ui/atoms';

import { MessageWrapper } from './styles';

type Props = {
	action: () => void;
};

export const PaidTextMessage = ({ action }: Props) => {
	const t = useTranslations('Chats');

	return (
		<MessageWrapper contentText={t('paidMessageAction')} onClick={action}>
			<ParticlesPlaceholder />
		</MessageWrapper>
	);
};
